import { useEffect, useState } from 'react';

const useGetApi = (url: string) => {
  const [data, setData] = useState();
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!url) return;

    setLoading(true);
    setError(null);

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then((responseData) => {
        setData(responseData);
        setLoading(false);
      })
      .catch((err) => {
        console.error('useGetApi fetch failed:', err);
        setError(err);
        setLoading(false);
      });
  }, [url]);

  return { data, error, loading };
};

export default useGetApi;
